const defExpression = 'changedFlag'
const eventName = 'change'
const vChecker = {
  bind: function (el, binding, vnode) {
    const { context, componentInstance } = vnode
    const { expression, modifiers } = binding
    const test = modifiers['test']
    // console.log({ el, binding, vnode, modifiers })

    let exp = expression || defExpression

    if (componentInstance) {
      componentInstance.$on(eventName, () => {
        el.dispatchEvent(new CustomEvent(eventName, { bubbles: true }))
      })
    }

    el.addEventListener(eventName, e => {
      if (test) {
        alert('v-checker : changed')
      }
      context[exp] = true
      context.$emit('set-change')
    })
  },
  unbind: function (el, binding, vnode) {
    const { componentInstance } = vnode
    if (componentInstance) {
      componentInstance.$off(eventName)
    }
    el.removeEventListener(eventName, () => {})
  }
}

export default vChecker
